export const focusTextLead = function () {
  $('#textInputModal').on('shown.bs.modal', function() {
    let requestLeadPhone   = $(this).find('#text-number');
    let  modalContent      = $(this).find('.modal-content');
    requestLeadPhone.on('focus', function() {
      modalContent.animate({
        scrollTop: 325
      });
    });
    if (!requestLeadPhone.val()) {
      modalContent.addClass("ab-open-keyboard-txt-modal");
      requestLeadPhone.trigger("focus");
    }
  });
}



// WEBPACK FOOTER //
// ./quick_view/optimization/ab-open-keyboard-txt-lead.js